// tslint:disable: max-classes-per-file
export class SLEntriesError extends Error {
  public messages: string[];
  constructor(messages: string[]) {
    super("");
    this.name = this.constructor.name;
    this.messages = messages;
  }
}

export class FatalError extends Error {
  constructor(message: string) {
    super(message);
    this.name = this.constructor.name;
  }
}

export class InvalidEntryError extends Error {
  constructor(message: string) {
    super(message);
    this.name = this.constructor.name;
  }
}

export class RuntimeError extends Error {
  constructor(message: string) {
    super(message);
    this.name = this.constructor.name;
  }
}

export class APIAnomalyError extends Error {
  constructor(message: string) {
    super(message);
    this.name = this.constructor.name;
  }
}
